export default __webpack_public_path__ + "static/media/AvertaStdCY-Regular.856b8f23.otf";